import { ServiceStatus } from 'types/analytics';

export const DEFAULT_EDITION_DATE_RANGE = { from: null, to: null };
export const DEFAULT_SERVICE_STATUS: ServiceStatus = {};
